import { useSelector } from 'react-redux'

import { defaultDomainSelector } from 'selectors/segment'
import { bookingLinkService } from 'services/analytics/booking_link_service'

/**
 * Hook that resolves custom domain vs default domain for a booking URL
 * and returns analytics-ready properties.
 *
 * @param {string | undefined} bookingUrl - The booking URL to check
 * @returns {{ custom_domain?: boolean, domain?: string }} Domain properties for tracking events
 */
export const useLinkDomainData = (bookingUrl) => {
  const defaultDomain = useSelector(defaultDomainSelector)
  const { isCustomDomain, linkDomain } = bookingLinkService.linkDomainData(bookingUrl, defaultDomain)
  const result = {}
  if (isCustomDomain !== undefined) result.custom_domain = isCustomDomain
  if (linkDomain !== undefined) result.domain = linkDomain
  return result
}
